// extracted by mini-css-extract-plugin
export default {"iframe":"style_iframe__rzW7r"};